<template>
	<BaseCard
		:is-viewable="isUserAllowedInLevel3"
		:is-editable="isUserAllowedInLevel2"
		:title="$t('opo_list_damage_assessor').toString()"
		@clickEdit="$router.push({ name: 'damagecases.payment', params: { id: $route.params.processId || $route.params.id } })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons v-if="isUserAllowedInLevel2 && showWarning">
			<div class="flex items-center">
				<font-awesome-icon icon="exclamation-triangle" class="text-red-700" />
			</div>
		</template>
		<div v-if="damageCase.damageAssessor">
			<div class="font-bold" v-if="rechnungsbetrag == null">
				<div v-if="payment?.status">
					<BaseCardRow :label="$t('status')" :value="statusLabel" :class="{ 'text-red-600 font-bold': showWarning }"></BaseCardRow>
				</div>
				<div v-else>
					{{ $t('data_not_stored') }}
				</div>
			</div>
			<div v-else>
				<BaseCardRow :label="$t('billing_value')" :value="formatedMoney(rechnungsbetrag)"></BaseCardRow>
				<BaseCardRow :label="$t('open_amount')" :value="formatedMoney(damageCase.paymentDamageAssessorOffenerBetrag)"></BaseCardRow>
				<BaseCardRow :label="$t('status')" :value="statusLabel" :class="{ 'text-red-600 font-bold': showWarning }"></BaseCardRow>
			</div>
		</div>
		<div v-else>{{ $t('no_expertise_stored') }}</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import Formatter from '@/mixins/Formatter';
import DunningStatus from '@/mixins/damagecase/DunningStatus';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'OPOListCard',
	components: { BaseCard, BaseCardRow },
	mixins: [Formatter, DunningStatus, Authentication],
	props: {
		damageCase: {},
		isProcessFinished: {},
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		isEditAllowed() {
			return this.damageCase.paymentDamageAssessorOffenerBetrag !== 0 || !this.damageCase?.paymentDamageAssessor || this.rechnungsbetrag === null;
		},
		rechnungsbetrag() {
			return this.damageCase?.paymentDamageAssessor?.rechnungsbetrag;
		},
		payment() {
			return this.damageCase?.paymentDamageAssessor;
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
		formatedMoney(money) {
			if (!money) {
				return '0,00 €';
			}
			return this.formatMoney(money);
		},
	},
};
</script>
